<template>
	<div class="list-container column">
		<div class="title">Brandskydd</div>
		<div class="switchbutton-wrapper">
			<SwitchButton
				class="switchbutton"
				v-for="(group, index) in fireProtectionGroupMap"
				:key="index"
				:label="group.text"
				v-model="group.isChecked"
				@input="filter(index)"
			/>
		</div>
		<div class="panel-list-header">
			<div class="panel-filler-icon" />
			<div class="panel-header-item">Namn</div>
			<div v-if="!isMobile" class="panel-header-item">Typ</div>
			<div v-if="!isMobile" class="panel-header-item">Grupp</div>
			<div class="panel-filler" />
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="fireProtection in fireProtections"
			:key="fireProtection.id"
			:class="fireProtection.id == activeFireProtection.id ? 'active' : ''"
			@click="onSelect(fireProtection)"
		>
			<div class="panel-list-item special">
				<div
					class="fireprotection-icon"
					:class="getType(fireProtection.inventoryType)"
				></div>
			</div>

			<div class="panel-list-item">{{ fireProtection.name }}</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ fireProtection.inventoryType }}
			</div>
			<div v-if="!isMobile" class="panel-list-item">
				{{ getFireProtectionGroup(fireProtection.fireProtectionType) }}
			</div>
			<div class="list-button" @click.stop="onEdit(fireProtection)">
				<i class="fas fa-edit"></i>
			</div>
			<div class="list-button" @click.stop="onDelete(fireProtection)">
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="fireProtections.length == 0">
			<p class="panel-list-item">Inga resultat</p>
		</div>
		<Pagination
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import iconMixin from '@/mixins/iconMixin.js';
import SwitchButton from '@/components/switchButton';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
	mixins: [iconMixin],
	components: {
		Pagination,
		SwitchButton
	},
	props: {
		fireProtections: Array,
		activeFireProtection: Object
	},
	data: () => ({
		fireProtectionGroupMap: []
	}),
	computed: {
		...mapState('fireProtectionStore', ['searchParams']),
		...mapGetters('fireProtectionStore', ['pagination']),
		...mapGetters('appStore', ['isMobile'])
	},
	methods: {
		...mapActions('fireProtectionStore', ['setCurrentPage', 'setPageSize']),
		onDelete(fireProtection) {
			this.$emit('delete', fireProtection);
		},
		onEdit(fireProtection) {
			this.$emit('edit', fireProtection);
		},
		onSelect(fireProtection) {
			if (!this.isMobile) {
				this.$emit('select', fireProtection);
			}
		},
		filter(index) {
			if (
				this.fireProtectionGroupMap.filter(group => group.isChecked).length > 0
			) {
				this.fireProtectionGroupMap.map(group => {
					group.isChecked = group.index === index;

					return group;
				});

				this.searchParams.FireProtectionType = this.fireProtectionGroupMap.find(
					group => group.isChecked
				).index;
			} else {
				delete this.searchParams.FireProtectionType;
			}

			this.$emit('search');
		},
		paginate(page) {
			this.setCurrentPage(page);
			this.$emit('search');
		},
		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.$emit('search');
		}
	},
	created() {
		this.fireProtectionGroupMap = Object.values(
			this.getFireProtectionGroupMap()
		).map((item, index) => {
			return { index, text: item, isChecked: false };
		});
	},
	beforeDestroy() {
		delete this.searchParams.FireProtectionType;
	}
};
</script>

<style lang="scss" scoped>
.panel-list-item.special {
  margin-right: 5px;
  max-width: 40px;
  position: relative;
}
.fireprotection-icon {
  background-color: white;
  top: -7px;
  width: 30px;
  height: 30px;
  z-index: 2;
  position: absolute;
  background-size: contain;
}

.switchbutton-wrapper {
  display: flex;
  flex-flow: row wrap;
  margin-bottom: 1rem;

  .switchbutton {
    font-weight: 600;
    margin-right: 10px;
    text-align: center;
	display: flex;
	flex-direction: column;
  }
}
</style>
